import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function HowItWorks() {
  const benefits = ['Access to four experts across strategy, design, content, and automation', 'Use your hours for any service—maximum flexibility', 'Direct Slack access for fast communication', '24-48 hour turnaround on most requests', 'Cancel anytime, no long-term commitment'];
  return <section id="how-it-works" className="py-32 bg-paper" data-id="element-83">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-85">
          <span className="text-terracotta font-medium tracking-[0.2em] uppercase text-xs mb-4 block" data-id="element-86">
            How It Works
          </span>
          <h2 className="text-5xl md:text-6xl font-serif text-ink mb-6 font-normal" data-id="element-87">
            Your on-demand creative team
          </h2>
          <p className="text-lg text-ink/70 max-w-2xl mx-auto font-normal" data-id="element-88">
            Buy a monthly retainer, use your hours for anything you need.
            Simple, flexible, and fast.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-8 md:p-12" data-id="element-89">
          <ul className="space-y-6" data-id="element-90">
            {benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-91">
                <Check className="w-6 h-6 text-terracotta flex-shrink-0 mr-4 mt-0.5" strokeWidth={2} data-id="element-92" />
                <span className="text-lg text-ink/80 font-normal leading-relaxed" data-id="element-93">
                  {benefit}
                </span>
              </li>)}
          </ul>

          <div className="mt-12 pt-8 border-t border-ink/10" data-id="element-94">
            <p className="text-center text-ink/60 font-normal" data-id="element-95">
              Choose a plan that fits your needs. Start, pause, or cancel
              anytime.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}